var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20542 0.0344238C2.34872 0.0344238 0.0341797 2.34897 0.0341797 5.20566C0.0341797 8.06235 2.34872 10.3769 5.20542 10.3769C8.06211 10.3769 10.3767 8.06235 10.3767 5.20566C10.3767 2.34897 8.06211 0.0344238 5.20542 0.0344238ZM8.20807 5.78951C8.20807 5.92713 8.09547 6.03973 7.95785 6.03973H6.03949V7.95809C6.03949 8.09571 5.92689 8.20831 5.78926 8.20831H4.62157C4.48394 8.20831 4.37135 8.09571 4.37135 7.95809V6.03973H2.45298C2.31536 6.03973 2.20276 5.92713 2.20276 5.78951V4.62181C2.20276 4.48419 2.31536 4.37159 2.45298 4.37159H4.37135V2.45323C4.37135 2.31561 4.48394 2.20301 4.62157 2.20301H5.78926C5.92689 2.20301 6.03949 2.31561 6.03949 2.45323V4.37159H7.95785C8.09547 4.37159 8.20807 4.48419 8.20807 4.62181V5.78951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.760eecf419ae978b6ed6ad958f45ee13.svg";
export { ForwardRef as ReactComponent };